import { render } from "./billetage.vue?vue&type=template&id=3f6cfd25&scoped=true"
import script from "./billetage.vue?vue&type=script&lang=js"
export * from "./billetage.vue?vue&type=script&lang=js"

import "./billetage.vue?vue&type=style&index=0&id=3f6cfd25&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6cfd25"]])

export default __exports__